import { createTheme } from '@mui/material/styles';
import { jaJP } from '@mui/material/locale';

export const theme = createTheme(
  {
    typography: {
      body2: { fontSize: '0.9rem' },
      caption: { fontSize: '0.775rem' },
    },
    components: {
      MuiListItemButton: {
        styleOverrides: {
          root: { minHeight: 52 },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            minHeight: 48,
            fontSize: '0.8125rem',
            paddingLeft: 14,
            paddingRight: 14,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: { minHeight: 48 },
        },
      },
      MuiBottomNavigation: {
        styleOverrides: {
          root: {
            height: 'calc(56px + env(safe-area-inset-bottom, 0px))',
            paddingBottom: 'env(safe-area-inset-bottom, 0px)',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          sizeSmall: { height: 28, fontSize: '0.775rem' },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          inputSizeSmall: { paddingTop: '7px', paddingBottom: '7px' },
        },
      },
    },
  },
  jaJP,
);
